<app-card
  [title]="'admin.service.subject.view.info_title'|translate"
  [cardOptionBtn]="true"
  cardOptionBtnValue="{{'admin.service.subject.view.edit_btn'|translate}}"
  [cardRouterLink]="'/back-office/service/subject/' + subject.id + '/edit'"
>
  <div class="row">
    <div class="col-sm-12 col-xl-6">
      <div class="row">
        <div class="col-sm-12 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.service_subject.subject'|translate}}</p>
          <label class="m-b-15">{{subject.name}}</label>
        </div>
        <div class="col-sm-12 col-xl-6">
          <p class="text-muted m-b-10">{{'doctrine.service_subject.status'|translate}}</p>
          <label class="m-b-15">{{(subject.status ? 'global.active' : 'global.inactive')|translate}}</label>
        </div>
        <div class="col-sm-12 col-xl-12">
          <p class="text-muted m-b-10">{{'doctrine.service_subject.attachments'|translate}}</p>
          <div class="row">
            <div
              *ngFor="let file of subject.attachments"
              class="col-sm-12 col-xl-6 d-flex align-items-center mb-2"
            >
              <a
                href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
                download="{{baseUrl + '/download?path=' + file.filename}}"
                class="btn btn-primary btn-file"
              >
                <span class="fa {{getFontAwesomeIconFromMIME(file.mimeType)}}"></span>
              </a>
              <a
                href="{{baseUrl + '/download?path=' + file.path + '&filename=' + file.filename}}"
                download="{{baseUrl + '/download?path=' + file.filename}}"
              >
                <div class="ms-2">
                  <p class="mb-0 text-break file-name">{{file.filename}}</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xl-6">
      <p class="text-muted m-b-10">{{'doctrine.service_subject.description'|translate}}</p>
      <div class="m-b-15" [innerHTML]="subject.description"></div>
    </div>
  </div>
</app-card>
<app-card hideHeader>
  <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.service.subject.view.tabs.solutions'|translate}}</a>
      <ng-template ngbNavContent>
        <app-service-subject-solution-overview [serviceSubject]="subject"
                                               *ngIf="subject.solutions"></app-service-subject-solution-overview>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.service.subject.view.tabs.service_tunnel'|translate}}</a>
      <ng-template ngbNavContent>
        <app-service-subject-item-overview [serviceSubject]="subject"
                                           *ngIf="subject.serviceSubjectItems"></app-service-subject-item-overview>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.service.subject.view.tabs.products'|translate}}</a>
      <ng-template ngbNavContent>
        <app-service-subject-products [serviceSubject]="subject"
                                      *ngIf="subject.id != null && subject.products != null"></app-service-subject-products>
      </ng-template>
    </div>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</app-card>
